import update from 'immutability-helper';
import { createReducer } from '../modules/helpers';
import { ActionTypes } from '../constants/index';

const initState = {
  activities: [],
  status: 'idle', // idle -> loading -> idle -> refreshing -> idle
};

export const activityReducer = createReducer(initState, {

  [ActionTypes.ACTIVITY_GET_REQUEST](state) {
    return update(state, {
      activities: { $set: [] },
      status: { $set: 'loading' },
    });
  },
  [ActionTypes.ACTIVITY_GET_SUCCESS](state, { payload }) {
    return update(state, {
      activities: { $set: payload.activities },
      status: { $set: 'idle' },
    });
  },
  [ActionTypes.ACTIVITY_GET_FAILURE](state) {
    return update(state, {
      activities: { $set: [] },
      status: { $set: 'idle' },
    });
  },
});



// WEBPACK FOOTER //
// ./scripts/reducers/activity.js